import { render } from "./RegulamentoAuth.vue?vue&type=template&id=3eaf6371"
import script from "./RegulamentoAuth.vue?vue&type=script&lang=js"
export * from "./RegulamentoAuth.vue?vue&type=script&lang=js"
script.render = render

export default script